<div class="content_container">

  <div class="prizes-container">

    <div class="each-prize">
      <div class="prize">
        <img src="assets/img/oppo-golf/Asset%201.png" alt="1st Place">
      </div>
      <h1>$5000+Reno6 Pro 5G</h1>
      <div class="container">
        <div class="tab-content team">
          <div class="team-container">
            <div class="flex_block">
              <img class="profile" src="https://gbarena-development.s3.amazonaws.com/users/avatars/defaults/default.png"
                   alt="team_image"/>
              <div class="info">
                <h1>hmdan-1765</h1>
                <div class="flex_block">
                  <div class="item">
                    <div class="flag_container_rounded">
                      <img
                        src="assets/img/flags/om.svg">
                    </div>

                    <p style="margin: 3px">Oman</p>
                  </div>
                  <!--            <div class="item">-->
                  <!--              <svg-icon name="capitain"></svg-icon>-->
                  <!--              <p>{{participant?.original?.leader?.username|truncate:20}}</p>-->
                  <!--            </div>-->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>


    <div class="each-prize">
      <div class="prize">
        <img src="assets/img/oppo-golf/Asset%202.png" alt="1st Place">

      </div>
      <h1>$2500+Reno6 5G</h1>
      <div class="container">
        <div class="tab-content team">
          <div class="team-container">
            <div class="flex_block">
              <img class="profile" src="https://gbarena-development.s3.amazonaws.com/users/avatars/defaults/Oman.user.jpg"
                   alt="team_image"/>
              <div class="info">
                <h1>A3DAM</h1>
                <div class="flex_block">
                  <div class="item">
                    <div class="flag_container_rounded">
                      <img
                        src="assets/img/flags/om.svg">
                    </div>

                    <p style="margin: 3px">Oman</p>
                  </div>
                  <!--            <div class="item">-->
                  <!--              <svg-icon name="capitain"></svg-icon>-->
                  <!--              <p>{{participant?.original?.leader?.username|truncate:20}}</p>-->
                  <!--            </div>-->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="each-prize">
      <div class="prize">
        <img src="assets/img/oppo-golf/Asset%203.png" alt="2nd Place">
      </div>
      <h1>$1000+Reno6 5G</h1>
      <div class="container">

        <div class="tab-content team">
          <div class="team-container">
            <div class="flex_block">
              <img class="profile" src="https://gbarena-development.s3.amazonaws.com/users/avatars/Avatar-QOlxM1KyeLC07jx.jpg"
                   alt="team_image"/>
              <div class="info">
                <h1>khald-salm-6717</h1>
                <div class="flex_block">
                  <div class="item">
                    <div class="flag_container_rounded">
                      <img
                        src="assets/img/flags/om.svg">
                    </div>

                    <p style="margin: 3px">Oman</p>
                  </div>
                  <!--            <div class="item">-->
                  <!--              <svg-icon name="capitain"></svg-icon>-->
                  <!--              <p>{{participant?.original?.leader?.username|truncate:20}}</p>-->
                  <!--            </div>-->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="each-prize">
      <div class="prize">
        <img src="assets/img/oppo-golf/Asset%204.png" alt="1st Place">
      </div>
      <h1>$500+Reno6 Z 5G</h1>
      <div class="container">

        <div class="tab-content team">
          <div class="team-container">
            <div class="flex_block">
              <img class="profile" src="https://gbarena-development.s3.amazonaws.com/users/avatars/Avatar-XP0FDyVd9Yyw0Jw.jpg"
                   alt="team_image"/>
              <div class="info">
                <h1>waa-liid-5757</h1>
                <div class="flex_block">
                  <div class="item">
                    <div class="flag_container_rounded">
                      <img
                        src="assets/img/flags/ae.svg">
                    </div>

                    <p style="margin: 3px">UAE</p>
                  </div>
                  <!--            <div class="item">-->
                  <!--              <svg-icon name="capitain"></svg-icon>-->
                  <!--              <p>{{participant?.original?.leader?.username|truncate:20}}</p>-->
                  <!--            </div>-->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="each-prize">
      <div class="prize">
        <img src="assets/img/oppo-golf/Asset%205.png" alt="1st Place">

      </div>
      <h1>Reno6 Z 5G</h1>
      <div class="container">

        <div class="tab-content team">
          <div class="team-container">
            <div class="flex_block">
              <img class="profile" src="https://gbarena-development.s3.amazonaws.com/users/avatars/Avatar-PuPfyDyhzRoH5B7.jpg"
                   alt="team_image"/>
              <div class="info">
                <h1>skWAL00D</h1>
                <div class="flex_block">
                  <div class="item">
                    <div class="flag_container_rounded">
                      <img
                        src="assets/img/flags/bh.svg">
                    </div>

                    <p style="margin: 3px">Bahrain</p>
                  </div>
                  <!--            <div class="item">-->
                  <!--              <svg-icon name="capitain"></svg-icon>-->
                  <!--              <p>{{participant?.original?.leader?.username|truncate:20}}</p>-->
                  <!--            </div>-->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>


</div>
